import GroupIndex from '../components/group/Index';
export default [
	{
		path:'',
		component:GroupIndex,
	}, 
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/group.js